export default ({
  actionItems,
}) => ({
  componentName: 'cell-actions',
  componentArgs: {
    actionItems,
  },
});
